import { MediaClient } from '../clients/media';
import {
  MediaUploadRequestMimeTypeEnum,
  MediaUploadRequestTypeEnum,
} from '../openapi';
import axios from 'axios';

const MIME_TYPE_MAP: Record<string, MediaUploadRequestTypeEnum> = {
  'image/jpeg': 'IMAGE',
  'image/png': 'IMAGE',
  'image/webp': 'IMAGE',
  'image/bmp': 'IMAGE',
  'image/heif': 'IMAGE',
  'image/heic': 'IMAGE',
  'image/heif-sequence': 'IMAGE',
  'image/heic-sequence': 'IMAGE',
  'image/gif': 'IMAGE',
  'image/svg+xml': 'IMAGE',
  'video/mp4': 'VIDEO',
  'model/gltf-binary': '3D_MODEL',
};

export const uploadMediaForProduct = (
  orgId: string,
  productId: string,
  filesToUpload: File[]
) =>
  MediaClient.createProductMedia(
    orgId,
    productId,
    filesToUpload.map((file: File) => ({
      type: MIME_TYPE_MAP[file.type],
      filename: file.name,
      filesize: file.size,
      mime_type: file.type as MediaUploadRequestMimeTypeEnum,
    }))
  ).then(({ data: mediaUploadResponses }) => {
    Promise.all(
      mediaUploadResponses.map((uploadResponse, i) =>
        axios.postForm(
          uploadResponse.url,
          {
            ...uploadResponse.fields,
            'Content-Type': uploadResponse.media_type,
            file: filesToUpload[i],
          },
          {
            // @ts-ignore
            skipAuth: true,
          }
        )
      )
    );
  });
